module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAMAAADXqc3KAAAAYFBMVEUAAADyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7Dyo7AdcuHlAAAAH3RSTlMA4vspz5yWcE/08+nc08O7pYh8QSQdyLOthGBWMw0Jk/PYlgAAAH9JREFUKM+9zTkSg0AMRFHNPuy7d7vvf0sjlwdKBaS8QMHvQHSyMRwMJbrd7gC8drrBTG37oMD8KOrz9ss614D1Zuk9WO6aQoMtQ8SsHVrO8lEP3KnCn6HVpaYy9UjCNfUge0QyyaFG8pCDQuJEnzgVDd9KDG+b2fAh41XW0Wm+6igPAdw4QKEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tinyspot.png
// module id = UE8f
// module chunks = 1